<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section class="dashboard-main container-fluid" *ngIf="permissionsReady && !permissions.canView">
    <div class="no-access-wrapper">
        <div class="no-access-card">
            <h4>No Access</h4>
            <p class="mb-0">You don't have permission to view Field Service Reports.</p>
        </div>
    </div>
</section>

<section class="contents-main" *ngIf="permissionsReady && permissions.canView && fsrDetail">
    <div class="container-fluid p-0">

        <!-- Header -->
        <div class="card table-card fsr-detail-card mb-3">
            <div class="table-toolbar flex-wrap gap-2">
                <h1 class="table-toolbar__title mb-0">
                    {{ fsrDetail.job_id }}
                    <small class="text-muted">/ {{ fsrDetail.report_serial_no }}</small>
                </h1>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                    <span class="badge badge-custom shadow" [ngClass]="getStatusBadgeClass(fsrDetail.status_display)">
                        {{ fsrDetail.status_display }}
                    </span>
                    <span class="badge badge-custom shadow"
                        [ngClass]="fsrDetail.origin === 'C' ? 'badge-priamry' : 'badge-cyan'">
                        {{ fsrDetail.origin_display }}
                    </span>
                    <!-- <span class="badge badge-custom shadow"
                        [ngClass]="fsrDetail.is_approved ? 'badge-success' : 'badge-gray'">
                        {{ fsrDetail.is_approved ? 'Approved' : 'Approval Pending' }}
                    </span> -->
                    <!-- Corrective FSRs stay out of the listing until the ticket closes out -->
                    <span class="badge badge-custom shadow badge-warning" *ngIf="fsrDetail.is_hidden">
                        Hidden until ticket resolves
                    </span>
                </div>
                <div class="ms-auto d-flex gap-2">
                    <button type="button" class="btn btn-outline-dark rounded" *ngIf="fsrDetail.ticket"
                        (click)="goToTicket()">
                        View Ticket #{{ fsrDetail.ticket }}
                    </button>
                    <button type="button" class="btn btn-dark rounded" (click)="goBack()">Back to FSR</button>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- Left: the report -->
            <div class="col-lg-7">
                <div class="card table-card mb-3">
                    <div class="table-toolbar">
                        <h2 class="table-toolbar__title">Report Details</h2>
                    </div>
                    <div class="p-4">
                        <dl class="fsr-detail-grid">
                            <dt>Location (Plant)</dt>
                            <dd>
                                {{ fsrDetail.plant?.stationName || '-' }}
                                <small class="text-muted d-block"
                                    *ngIf="fsrDetail.plant_city || fsrDetail.plant_region">
                                    {{ locationSubtitle }}
                                </small>
                            </dd>

                            <dt>Customer Name</dt>
                            <dd>{{ fsrDetail.customer_detail?.full_name || '-' }}</dd>

                            <dt>Job Visit Type</dt>
                            <dd>{{ fsrDetail.job_visit_type_display || '-' }}</dd>

                            <dt>Complaint Type</dt>
                            <dd>{{ fsrDetail.complaint_type_display || '-' }}</dd>

                            <dt>Panel Capacity</dt>
                            <dd>
                                <table class="fsr-panel-groups" *ngIf="panelGroupRows.length; else noPanelGroups">
                                    <thead>
                                        <tr>
                                            <th>No. of Panels</th>
                                            <th>Panel Capacity</th>
                                            <th>Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let group of panelGroupRows">
                                            <td>{{ group.number_of_panels }}</td>
                                            <td>{{ group.panel_capacity }}</td>
                                            <td>{{ group.subtotal }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <ng-template #noPanelGroups>-</ng-template>
                            </dd>

                            <dt>System Capacity DC</dt>
                            <dd>{{ fsrDetail.system_capacity_dc || '-' }}</dd>

                            <dt>ZC Staff Name</dt>
                            <dd>{{ fsrDetail.assigned_to?.first_name || 'Unassigned' }}</dd>

                            <dt>Visit Date</dt>
                            <dd>{{ fsrDetail.visit_date ? (fsrDetail.visit_date | date: 'mediumDate') : '-' }}</dd>

                            <dt>Time In / Out</dt>
                            <dd>{{ fsrDetail.time_in || '-' }} &ndash; {{ fsrDetail.time_out || '-' }}</dd>

                            <dt>Total Worked Hours</dt>
                            <dd>{{ fsrDetail.total_worked_hours || '-' }}</dd>

                            <dt>Filed By</dt>
                            <dd>{{ fsrDetail.filed_by?.first_name || '-' }}</dd>

                            <dt *ngIf="fsrDetail.is_approved">Approved By</dt>
                            <dd *ngIf="fsrDetail.is_approved">
                                {{ fsrDetail.approved_by?.first_name || '-' }}
                                <small class="text-muted" *ngIf="fsrDetail.approved_at">
                                    on {{ fsrDetail.approved_at | date: 'medium' }}
                                </small>
                            </dd>
                        </dl>

                        <div class="mt-4">
                            <h6>Description of Job</h6>
                            <p class="mb-0 text-pre-wrap">{{ fsrDetail.description_of_job || '-' }}</p>
                        </div>

                        <div class="mt-4">
                            <h6>Checks</h6>
                            <ul class="fsr-check-list mb-0">
                                <li *ngFor="let check of checks">
                                    <span class="badge badge-custom badge-sm"
                                        [ngClass]="check.value ? 'badge-success' : 'badge-gray'">
                                        {{ check.value ? 'Yes' : 'No' }}
                                    </span>
                                    {{ check.label }}
                                </li>
                            </ul>
                        </div>

                        <div class="mt-4">
                            <h6>Replacement</h6>
                            <ul class="mb-0" *ngIf="replacements.length; else noReplacements">
                                <li *ngFor="let item of replacements">{{ item }}</li>
                            </ul>
                            <ng-template #noReplacements>
                                <p class="mb-0 text-muted">No replacements recorded.</p>
                            </ng-template>
                        </div>

                        <div class="mt-4">
                            <h6>General Remarks</h6>
                            <p class="mb-0 text-pre-wrap">{{ fsrDetail.remarks || '-' }}</p>
                        </div>
                    </div>
                </div>

                <!-- Attachments -->
                <div class="card table-card">
                    <div class="table-toolbar">
                        <h2 class="table-toolbar__title">Attachments</h2>
                    </div>
                    <div class="p-4">
                        <div class="attachment-grid" *ngIf="fsrDetail.attachments?.length; else noAttachments">
                            <a *ngFor="let file of fsrDetail.attachments" class="attachment-bubble"
                                [href]="file.file_url" target="_blank" rel="noopener">
                                <img *ngIf="file.type === 'image'" [src]="file.file_url" [alt]="file.file_name">
                                <video *ngIf="file.type === 'video'" [src]="file.file_url" controls
                                    preload="metadata"></video>
                                <span class="attachment-name">{{ file.file_name }}</span>
                            </a>
                        </div>
                        <ng-template #noAttachments>
                            <p class="empty-placeholder mb-0">No attachments uploaded.</p>
                        </ng-template>
                    </div>
                </div>
            </div>

            <!-- Right: the log -->
            <div class="col-lg-5">
                <div class="card table-card">
                    <div class="table-toolbar">
                        <h2 class="table-toolbar__title">Activity Log</h2>
                    </div>
                    <div class="p-4 activity-list">
                        <ng-container *ngIf="fsrDetail.activities?.length; else noActivity">
                            <div class="activity-item" *ngFor="let activity of fsrDetail.activities">
                                <div class="activity-head">
                                    <strong>{{ activity.created_by?.first_name || 'System' }}</strong>
                                    <small class="text-muted">{{ activity.created_at | date: 'medium' }}</small>
                                </div>
                                <div class="activity-status" *ngIf="activity.new_status !== null">
                                    <span class="badge badge-custom badge-sm"
                                        *ngIf="activity.old_status_display"
                                        [ngClass]="getStatusBadgeClass(activity.old_status_display)">
                                        {{ activity.old_status_display }}
                                    </span>
                                    <i class="fa fa-arrow-right activity-arrow" *ngIf="activity.old_status_display" aria-hidden="true"></i>
                                    <span class="badge badge-custom badge-sm"
                                        [ngClass]="getStatusBadgeClass(activity.new_status_display)">
                                        {{ activity.new_status_display }}
                                    </span>
                                </div>
                                <p class="activity-message text-pre-wrap mb-0" *ngIf="activity.message">
                                    {{ activity.message }}
                                </p>
                            </div>
                        </ng-container>
                        <ng-template #noActivity>
                            <p class="empty-placeholder mb-0">No activity recorded yet.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
